import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.element.addEventListener('change', this.updateStatus.bind(this))
  }

  updateStatus(event) {
    const newStatus = event.target.value
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: JSON.stringify({
        status: newStatus
      })
    }).then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
  }

  disconnect() {
    this.element.removeEventListener('change', this.updateStatus)
  }
}
